export default "__VITE_ASSET__BYmhdo23__"